import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, mergeProps as _mergeProps, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "card-title flex-grow-1 justify-content-between align-items-center mb-0" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = { class: "font-semi-bold font-size-12" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "d-flex" }
const _hoisted_7 = { class: "flex-grow-1" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = ["id"]
const _hoisted_10 = { class: "d-block mb-0 small text-muted" }
const _hoisted_11 = ["id"]
const _hoisted_12 = { class: "d-block mb-0 small text-muted" }
const _hoisted_13 = ["id"]
const _hoisted_14 = { class: "d-block mb-0 small text-muted" }
const _hoisted_15 = ["id"]
const _hoisted_16 = { class: "d-block mb-0 small text-muted" }
const _hoisted_17 = ["id"]
const _hoisted_18 = { class: "d-block mb-0 small text-muted" }
const _hoisted_19 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "third_edit_contact_nationality"
}
const _hoisted_20 = { class: "d-block mb-0 small text-muted" }
const _hoisted_21 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "third_edit_contact_birthplaceCity"
}
const _hoisted_22 = { class: "d-block mb-0 small text-muted" }
const _hoisted_23 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "third_edit_identity_postalCode_country"
}
const _hoisted_24 = { class: "d-block mb-0 small text-muted" }
const _hoisted_25 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "third_edit_identity_postalCode_cityOfBirth"
}
const _hoisted_26 = { class: "d-block mb-0 small text-muted" }
const _hoisted_27 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "third_edit_identity_postalCode_country"
}
const _hoisted_28 = { class: "d-block mb-0 small text-muted" }
const _hoisted_29 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "third_edit_contact_address"
}
const _hoisted_30 = { class: "d-block mb-0 small text-muted" }
const _hoisted_31 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "third_edit_contact_address"
}
const _hoisted_32 = { class: "d-block mb-0 small text-muted" }
const _hoisted_33 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "third_edit_contact_address"
}
const _hoisted_34 = { class: "d-block mb-0 small text-muted" }
const _hoisted_35 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "third_edit_identity_birthDate"
}
const _hoisted_36 = { class: "d-block mb-0 small text-muted" }
const _hoisted_37 = { class: "row items-center justify-end" }
const _hoisted_38 = { class: "d-block mb-0 small text-muted" }
const _hoisted_39 = { class: "d-block mb-0 small text-muted" }
const _hoisted_40 = ["id"]
const _hoisted_41 = { class: "d-block mb-0 small text-muted" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_date = _resolveComponent("q-date")!
  const _component_q_popup_proxy = _resolveComponent("q-popup-proxy")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_toggle = _resolveComponent("q-toggle")!
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_q_list, { class: "position-relative" }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "tw-unchor",
        id: 'section-contact' +_ctx.tabPosition
      }, null, 8, _hoisted_1),
      _createVNode(_component_q_expansion_item, {
        "switch-toggle-side": "",
        "header-class": "card-header bg-transparent no-border p-4",
        class: "card tw-items-dashed-group tw-items-group-with-bg",
        modelValue: _ctx.showContactExpense,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showContactExpense) = $event))
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("middleOffice.party.organization.section.contact")), 1)
            ])
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.correspondentList, (value, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "p-2 bg-white default-border-radius mb-3",
                key: index
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      (value.businessData)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
                            id: 'demand_edit_contactPerson_title_' + index
                          }, [
                            _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t("main.labels.title")), 1),
                            _createVNode(_component_q_select, {
                              "data-testid": 'demand_edit_contactPerson_title_' + index,
                              dense: "",
                              outlined: "",
                              "emit-value": "",
                              "map-options": "",
                              modelValue: value.businessData.titleCode,
                              "onUpdate:modelValue": ($event: any) => ((value.businessData.titleCode) = $event),
                              options: _ctx.title,
                              disable: _ctx.isMO
                            }, null, 8, ["data-testid", "modelValue", "onUpdate:modelValue", "options", "disable"])
                          ], 8, _hoisted_9))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", {
                        id: `middleOffice_party_${_ctx.tabPosition}_organization_correspondent_${index}_familyName`,
                        class: "col-lg-3 col-md-6 col-sm-12 form-control no-border"
                      }, [
                        _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t("demand.filtreMenu.name")), 1),
                        _createVNode(_component_q_input, {
                          dense: "",
                          outlined: "",
                          "model-value": _ctx.getCorrespondentNameInput(value),
                          "onUpdate:modelValue": val => _ctx.setCorrespondentNameInput(value, val),
                          disable: _ctx.isMO
                        }, null, 8, ["model-value", "onUpdate:modelValue", "disable"])
                      ], 8, _hoisted_11),
                      _createElementVNode("div", {
                        id: `middleOffice_party_${_ctx.tabPosition}_organization_correspondent_${index}_familyName`,
                        class: "col-lg-3 col-md-6 col-sm-12 form-control no-border"
                      }, [
                        _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t("main.labels.usageName")), 1),
                        _createVNode(_component_q_input, {
                          dense: "",
                          outlined: "",
                          "model-value": value.middleName,
                          disable: _ctx.isMO
                        }, null, 8, ["model-value", "disable"])
                      ], 8, _hoisted_13),
                      _createElementVNode("div", {
                        id: `middleOffice_party_${_ctx.tabPosition}_organization_correspondent_${index}_firstName`,
                        class: "col-lg-3 col-md-6 col-sm-12 form-control no-border"
                      }, [
                        _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t("middleOffice.party.organization.contact.firstName")), 1),
                        _createVNode(_component_q_input, {
                          dense: "",
                          outlined: "",
                          "model-value": _ctx.getCorrespondentFirstNameInput(value),
                          "onUpdate:modelValue": val => _ctx.setCorrespondentFirstNameInput(value, val),
                          disable: _ctx.isMO
                        }, null, 8, ["model-value", "onUpdate:modelValue", "disable"])
                      ], 8, _hoisted_15),
                      _createElementVNode("div", {
                        id: `middleOffice_party_${_ctx.tabPosition}_organization_correspondent_${index}_qualificationType`,
                        class: "col-lg-3 col-md-6 col-sm-12 form-control no-border"
                      }, [
                        _createElementVNode("label", _hoisted_18, [
                          _createTextVNode(_toDisplayString(_ctx.$t("middleOffice.party.organization.contact.qualificationType")) + " ", 1),
                          _cache[1] || (_cache[1] = _createElementVNode("span", { class: "text-danger" }, "*", -1))
                        ]),
                        _createVNode(_component_q_select, {
                          dense: "",
                          outlined: "",
                          "emit-value": "",
                          "map-options": "",
                          "model-value": value.qualificationType?.type?.value,
                          disable: _ctx.isMO,
                          options: _ctx.qualificationTypeOptions,
                          "onUpdate:modelValue": (val) => _ctx.updateQualificationType(value, val)
                        }, null, 8, ["model-value", "disable", "options", "onUpdate:modelValue"])
                      ], 8, _hoisted_17),
                      (value.businessData)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t("demand.filtreMenu.nationality")), 1),
                              _createVNode(_component_q_input, {
                                "data-testid": "third_edit_contact_nationality",
                                dense: "",
                                outlined: "",
                                disable: _ctx.isMO,
                                modelValue: value.businessData.nationality,
                                "onUpdate:modelValue": ($event: any) => ((value.businessData.nationality) = $event)
                              }, null, 8, ["disable", "modelValue", "onUpdate:modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_21, [
                              _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t("demand.filtreMenu.birthplacecity")), 1),
                              _createVNode(_component_q_tooltip, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.getBirthplaceDisplay(value)), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_q_select, {
                                "data-testid": "third_edit_identity_postalCode_cityOfBirth",
                                dense: "",
                                outlined: "",
                                "use-input": "",
                                "hide-selected": "",
                                "fill-input": "",
                                "model-value": _ctx.getBirthplaceDisplay(value),
                                options: _ctx.postalCodes,
                                "emit-value": "",
                                "map-options": "",
                                "onUpdate:modelValue": val => _ctx.onBirthplaceChange(value, val),
                                disable: _ctx.isMO
                              }, {
                                option: _withCtx((scope) => [
                                  _createVNode(_component_q_item, _mergeProps({ ref_for: true }, scope.itemProps), {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_section, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(scope.opt.label), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1040)
                                ]),
                                _: 1
                              }, 8, ["model-value", "options", "onUpdate:modelValue", "disable"])
                            ]),
                            _createElementVNode("div", _hoisted_23, [
                              _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t("demand.filtreMenu.birthplaceCountry")), 1),
                              _createVNode(_component_q_input, {
                                "data-testid": "third_edit_contact_country",
                                dense: "",
                                outlined: "",
                                "model-value": _ctx.getBirthplaceCountryDisplay(value),
                                readonly: ""
                              }, null, 8, ["model-value"])
                            ]),
                            _createElementVNode("div", _hoisted_25, [
                              _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.$t("demand.filtreMenu.zipCode_City")), 1),
                              _createVNode(_component_q_tooltip, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.getResidenceDisplay(value)), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_q_select, {
                                "data-testid": "third_edit_identity_postalCode_cityOfBirth",
                                dense: "",
                                outlined: "",
                                "use-input": "",
                                "hide-selected": "",
                                "fill-input": "",
                                "model-value": _ctx.getResidenceDisplay(value),
                                options: _ctx.postalCodes,
                                "emit-value": "",
                                "map-options": "",
                                "onUpdate:modelValue": val => _ctx.onResidenceChange(value, val),
                                disable: _ctx.isMO
                              }, {
                                option: _withCtx((scope) => [
                                  _createVNode(_component_q_item, _mergeProps({ ref_for: true }, scope.itemProps), {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_section, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(scope.opt.label), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1040)
                                ]),
                                _: 1
                              }, 8, ["model-value", "options", "onUpdate:modelValue", "disable"])
                            ]),
                            _createElementVNode("div", _hoisted_27, [
                              _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.$t("demand.filtreMenu.country")), 1),
                              _createVNode(_component_q_input, {
                                "data-testid": "third_edit_contact_country",
                                dense: "",
                                outlined: "",
                                disable: _ctx.isMO,
                                modelValue: value.businessData.country,
                                "onUpdate:modelValue": ($event: any) => ((value.businessData.country) = $event)
                              }, null, 8, ["disable", "modelValue", "onUpdate:modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_29, [
                              _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.$t("demand.filtreMenu.address")), 1),
                              _createVNode(_component_q_input, {
                                "data-testid": "third_edit_contact_address",
                                dense: "",
                                outlined: "",
                                disable: _ctx.isMO,
                                modelValue: value.businessData.address,
                                "onUpdate:modelValue": ($event: any) => ((value.businessData.address) = $event)
                              }, null, 8, ["disable", "modelValue", "onUpdate:modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_31, [
                              _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.$t("middleOffice.party.organization.address.street")), 1),
                              _createVNode(_component_q_input, {
                                "data-testid": "third_edit_contact_addressSupplement",
                                dense: "",
                                outlined: "",
                                disable: _ctx.isMO,
                                modelValue: value.businessData.adressNo,
                                "onUpdate:modelValue": ($event: any) => ((value.businessData.adressNo) = $event)
                              }, null, 8, ["disable", "modelValue", "onUpdate:modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_33, [
                              _createElementVNode("label", _hoisted_34, _toDisplayString(_ctx.$t("middleOffice.party.organization.establishments.address.lieuDit")), 1),
                              _createVNode(_component_q_input, {
                                "data-testid": "third_edit_contact_addressSupplement",
                                dense: "",
                                outlined: "",
                                disable: _ctx.isMO,
                                modelValue: value.businessData.adressSupplement,
                                "onUpdate:modelValue": ($event: any) => ((value.businessData.adressSupplement) = $event)
                              }, null, 8, ["disable", "modelValue", "onUpdate:modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_35, [
                              _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.$t("demand.filtreMenu.birthdate")), 1),
                              _createVNode(_component_q_input, {
                                "data-testid": "third_edit_identity_birthDate",
                                dense: "",
                                outlined: "",
                                disable: _ctx.isMO,
                                modelValue: value.businessData.birthDate,
                                "onUpdate:modelValue": ($event: any) => ((value.businessData.birthDate) = $event),
                                mask: _ctx.maskInput,
                                rules: [(val) => _ctx.validateBirthDate(val)]
                              }, {
                                append: _withCtx(() => [
                                  _createVNode(_component_q_icon, {
                                    name: "event",
                                    class: "cursor-pointer"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_popup_proxy, {
                                        ref_for: true,
                                        ref: "qDateProxy",
                                        cover: "",
                                        "transition-show": "scale",
                                        "transition-hide": "scale"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_q_date, {
                                            modelValue: value.businessData.birthDate,
                                            "onUpdate:modelValue": ($event: any) => ((value.businessData.birthDate) = $event),
                                            mask: _ctx.maskFormat
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", _hoisted_37, [
                                                _withDirectives(_createVNode(_component_q_btn, {
                                                  label: _ctx.$t('task.completeDocument.party.person.financialSituation.close'),
                                                  color: "primary",
                                                  flat: ""
                                                }, null, 8, ["label"]), [
                                                  [_directive_close_popup]
                                                ])
                                              ])
                                            ]),
                                            _: 1
                                          }, 8, ["modelValue", "onUpdate:modelValue", "mask"])
                                        ]),
                                        _: 2
                                      }, 1536)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["disable", "modelValue", "onUpdate:modelValue", "mask", "rules"])
                            ])
                          ], 64))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value.contactCorrespondent, (vl, idx) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: 'contact-' + idx
                        }, [
                          (vl.contactMechanism?.type?.id === 'PHONE_CONTACT')
                            ? (_openBlock(), _createElementBlock("div", {
                                class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
                                key: 'phone-' + idx
                              }, [
                                _createElementVNode("label", _hoisted_38, _toDisplayString(_ctx.$t("middleOffice.party.organization.meansOfCommunication.phoneNumber")), 1),
                                _createVNode(_component_q_input, {
                                  dense: "",
                                  outlined: "",
                                  modelValue: vl.contactMechanism.phoneNumber,
                                  "onUpdate:modelValue": ($event: any) => ((vl.contactMechanism.phoneNumber) = $event),
                                  disable: _ctx.isMO
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "disable"])
                              ]))
                            : _createCommentVNode("", true),
                          (vl.contactMechanism?.type?.id === 'EMAIL_CONTACT')
                            ? (_openBlock(), _createElementBlock("div", {
                                class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
                                key: 'email-' + idx
                              }, [
                                _createElementVNode("label", _hoisted_39, _toDisplayString(_ctx.$t("middleOffice.party.organization.meansOfCommunication.emailAddress")), 1),
                                _createVNode(_component_q_input, {
                                  dense: "",
                                  outlined: "",
                                  modelValue: vl.contactMechanism.emailAddress,
                                  "onUpdate:modelValue": ($event: any) => ((vl.contactMechanism.emailAddress) = $event),
                                  rules: [(val) => _ctx.isValidEmail(val)],
                                  disable: _ctx.isMO
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "rules", "disable"])
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 128)),
                      _createElementVNode("div", {
                        id: `middleOffice_party_${_ctx.tabPosition}_organization_correspondent_${index}_signingAuthority`,
                        class: "col-lg-3 col-md-6 col-sm-12 form-control no-border"
                      }, [
                        _createElementVNode("label", _hoisted_41, _toDisplayString(_ctx.$t("middleOffice.party.organization.contact.signingAuthority")), 1),
                        _createVNode(_component_q_toggle, {
                          "data-testid": 'demand_edit_contactPerson_signingAuthority_toggle' +
                        index
                        ,
                          modelValue: value.signingAuthority,
                          "onUpdate:modelValue": ($event: any) => ((value.signingAuthority) = $event),
                          disable: _ctx.isMO
                        }, null, 8, ["data-testid", "modelValue", "onUpdate:modelValue", "disable"])
                      ], 8, _hoisted_40)
                    ])
                  ])
                ])
              ]))
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}